import AutocompleteInput from './container';

export default AutocompleteInput;



// WEBPACK FOOTER //
// ./src/components/AutocompleteInput/index.js